module.exports = __webpack_public_path__ + "static/media/signup-select-img.c10fb58e.svg";